import { render, staticRenderFns } from "./DetailSettingsEditContent.vue?vue&type=template&id=53260866&scoped=true"
import script from "./DetailSettingsEditContent.vue?vue&type=script&lang=ts"
export * from "./DetailSettingsEditContent.vue?vue&type=script&lang=ts"
import style0 from "./DetailSettingsEditContent.vue?vue&type=style&index=0&id=53260866&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53260866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53260866')) {
      api.createRecord('53260866', component.options)
    } else {
      api.reload('53260866', component.options)
    }
    module.hot.accept("./DetailSettingsEditContent.vue?vue&type=template&id=53260866&scoped=true", function () {
      api.rerender('53260866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/DetailSettingsEditContent.vue"
export default component.exports